<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content">
                <div class="row position-relative">

                    <div class="col-12 col-md-7 mt-5">
                        <slot name="image-carousel"></slot>
                    </div>

                    <div class="col-12 col-md-5 mt-md-5">
                        <div>
                            <!-- START SINGLEITEM_DETAILS -->
                            <div class="producertag h6 producer text-muted"
                                v-if="currentVariation.filter.hasManufacturer">
                                {{ currentVariation.item.manufacturer.externalName }}
                            </div>

                            <!-- STORE SPECIALS -->
                            <slot name="store-special">
                                <item-store-special
                                    v-if="storeSpecial || currentVariation.variation.bundleType === 'bundle' || currentVariation.item.itemType === 'set'"
                                    :store-special="storeSpecial"
                                    :recommended-retail-price="currentVariation.prices.rrp"
                                    :variation-retail-price="currentVariation.prices.default"
                                    :special-offer-price="currentVariation.prices.specialOffer"
                                    :decimal-count="decimalCount" :bundle-type="currentVariation.variation.bundleType"
                                    :item-type="currentVariation.item.itemType">
                                </item-store-special>
                            </slot>
                            <!-- ./STORE SPECIALS -->

                            <h1 class="h2 title">
                                <span>
                                    {{ currentVariation | itemName }}
                                </span>
                            </h1>

                            <slot name="tag-list"></slot>

                            <p class="single-description"
                                v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"
                                v-html="currentVariation.texts.shortDescription"></p>

                            <hr>

                            <div class="mb-5">
                                <span class="articlenumber small text-muted">
                                    <b>{{ $translate("Ceres::Template.singleItemNumber") }} </b>
                                    <span>{{ currentVariation.item.id }}</span>
                                </span>
                            </div>

                            <!-- Variation -->
                            <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                                <variation-select></variation-select>
                            </div>
                            <!-- /Variation -->

                            <!-- Item Bundle -->
                            <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                                :bundle-type="currentVariation.variation.bundleType"
                                :bundle-components="currentVariation.bundleComponents"></item-bundle>
                            <!-- /Item Bundle -->

                            <slot name="before-price"></slot>

                            <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                                <order-property-list></order-property-list>
                            </div>

                            <graduated-prices></graduated-prices>

                            <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

                            <slot name="after-price"></slot>

                            <item-availability></item-availability>

                            <div class="my-3">
                                <div class="w-100">
                                    <slot name="before-add-to-basket"></slot>
                                </div>
                                <div v-if="downLoadLink" class="add-to-basket-container">
                                    <a type="button" class="btn btn-block btn-primary btn-appearance"
                                        :href="'https://cdn02.plentymarkets.com/oueuwrwk0stw/propertyItems/' + downLoadLink"
                                        target="_blank">
                                        Download
                                    </a>
                                </div>


                                <!--<div v-else-if="!isLoggedIn" class="add-to-basket-container">
                                    <button type="button" class="btn btn-block btn-primary btn-appearance"
                                            data-toggle="modal" data-target="#buyModal"
                                            :disabled="!(currentVariation.filter && currentVariation.filter.isSalable)">
                                        Jetzt kaufen
                                    </button>
                                </div>-->
                                <!--<div v-else-if="user && user.userData && b2bCustomerClassArr.includes(user.userData.classId + '')">-->
                                <div>
                                    <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                                        {{ $translate("Ceres::Template.singleItemSetInfo") }}
                                    </div>
                                    <div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 my-3">
                                        <add-to-basket :variation-id="currentVariation.variation.id"
                                            :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                            :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                            :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                            :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                            :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                            :order-properties="currentVariation.properties.filter(function (prop) { return prop.property.isOderProperty })"
                                            :has-order-properties="currentVariation.hasOrderProperties"
                                            :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                            :use-large-scale="false" :show-quantity="true"
                                            :item-url="currentVariation | itemURL"
                                            :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                            :has-price="currentVariation | hasItemDefaultPrice">
                                        </add-to-basket>
                                    </div>
                                </div>
                                <div class="w-100">
                                    <slot name="after-add-to-basket"></slot>
                                </div>
                            </div>

                            <div v-if="isWishListEnabled" class="row">
                                <div class="col-12 wishlist-btn">
                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                </div>
                            </div>


                            <div class="shipping__wrapper">
                                <div class="shipping__headline">{{ $translate("DIAHappyKidz::Template.shippingHeadline")
                                    }}</div>
                                <div class="shipping__text shipping__text--de"
                                    v-if="Math.round(currentVariation.prices.default.price.value * 100) / 100 < 125">{{
                                        $translate("DIAHappyKidz::Template.shippingDe") }}</div>
                                <div class="shipping__text shipping__text--de-free" v-else>{{
                                    $translate("DIAHappyKidz::Template.shippingDeFree") }}</div>

                                <div class="shipping__text shipping__text--eu"
                                    v-if="Math.round(currentVariation.prices.default.price.value * 100) / 100 < 125">{{
                                        $translate("DIAHappyKidz::Template.shippingEu") }}</div>
                                <div class="shipping__text shipping__text--eu-free" v-else>{{
                                    $translate("DIAHappyKidz::Template.shippingEuFree") }}</div>
                            </div>


                            <!-- ./ITEM DETAIL -->

                            <slot name="additional-content-after-add-to-basket"></slot>

                            <hr>
                            <slot name="additional-content-after-vat"></slot>
                            <!-- END SINGLEITEM_DETAILS -->
                        </div>
                    </div>

                    <div class="col-12 col-md-7">
                        <!-- ITEM DESCRIPTION -->
                        <div class="my-5">
                            <ul class="nav nav-tabs">
                                <li class="nav-item" v-if="isDescriptionTabActive">
                                    <span class="nav-link active">{{
                                        $translate("Ceres::Template.singleItemDescription") }}</span>
                                </li>

                                <!-- <li class="nav-item d-none" v-if="isTechnicalDataTabActive">
                                    <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                        class="nav-link" data-toggle="tab"
                                        :href="'#data-' + currentVariation.variation.id" role="tab">{{
                                            $translate("Ceres::Template.singleItemTechnicalData") }}</a>
                                </li>

                                <li class="nav-item d-none">
                                    <a :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }"
                                        class="nav-link" data-toggle="tab" href="#assessments-details" role="tab">{{
                                            $translate("Ceres::Template.singleItemMoreDetails") }}</a>
                                </li>

                                <slot name="add-detail-tabs"></slot> -->
                            </ul>

                            <div class="tab-content overflow-hidden">
                                <div class="tab-pane active" :id="'details-' + currentVariation.variation.id"
                                    role="tabpanel" v-if="isDescriptionTabActive">
                                    <div class="my-4" v-html="currentVariation.texts.description">
                                    </div>

                                    <hr class="desc-line">

                                    <slot name="properties"></slot>

                                    <hr class="desc-line">

                                    <div class="my-4" v-html="currentVariation.texts.technicalData">
                                    </div>
                                    <a v-if="hasManufacturerDataPart2 || hasManufacturerDataPart1"
                                        data-target="#eusafety" class="mt-5 d-block" data-toggle="modal" href="#">
                                        ⓘ Herstellerinformationen
                                    </a>

                                </div>


                            </div>
                        </div>
                        <!-- ./ITEM DESCRIPTION -->
                    </div>
                    <div class="col-12 col-md-5">
                        <div class="mb-4 mt-md-5 single-guarantee-label" v-if="isGuaranteeLabelVisible">
                            <div class="widget widget-guarantee-label">
                                <button type="button" class="guarantee-badge-toggle btn-collapse p-0 border-0 bg-transparent"
                                    :class="{ collapsed: !guaranteeLabelExpanded }"
                                    @click="guaranteeLabelExpanded = !guaranteeLabelExpanded"
                                    :aria-expanded="guaranteeLabelExpanded.toString()"
                                    :aria-label="$translate('Ceres::Widget.guaranteeLabelBadgeAlt')">
                                    <guarantee-badge :guarantee="currentVariation.variation.durabilityYears"></guarantee-badge>
                                </button>

                                <div class="guarantee-label-collapse" v-if="guaranteeLabelExpanded">
                                    <guarantee-label-full
                                        :guarantee="currentVariation.variation.durabilityYears"
                                        :brand="guaranteeLabelBrand"
                                        :model="currentVariation.variation.model">
                                    </guarantee-label-full>
                                </div>
                            </div>
                        </div>

                        <template v-for="propertyGroup in currentVariation.variationProperties">
                            <div v-if="propertyGroup.id === 5" class="properties__wrapper properties__siegel">
                                <div v-for="property in propertyGroup.properties" class="properties">
                                    <span v-if="property.id" class="properties__property-value">
                                        <img :src="'https://cdn02.plentymarkets.com/20a5y485cyym/frontend/happykidz/Pruefsiegel/' + property.id + '.png'"
                                            :alt="property.names.name">
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template v-if="currentVariation.variationProperties">

                            <div class="properties__wrapper" v-if="filteredVariationProperties.length > 0">
                                <template v-for="property in filteredVariationProperties" class="properties">
                                    <div>
                                        <strong v-if="property.names" class="properties__property-name">{{
                                            property.names.name }}</strong>
                                        <span v-if="property.values && property.cast == 'file'"
                                            class="properties__property-value"><a
                                                :href="'https://cdn02.plentymarkets.com/20a5y485cyym/propertyItems/' + property.values.value"
                                                target="_blank">Download</a></span>
                                        <span v-else-if="property.values" v-html="property.values.value"
                                            class="properties__property-value"></span>
                                    </div>
                                </template>
                            </div>
                        </template>

                        <template v-if="currentVariation.variationProperties">
                            <div class="properties__wrapper properties__multiselect"
                                v-if="multiSelectProperties.length > 0">
                                <template v-for="property in multiSelectProperties" class="properties">
                                    <div>
                                        <strong v-if="property.names" class="properties__property-name">{{
                                            property.names.name }}</strong>
                                        <div v-for="value in propertyValues(property)"
                                            class="properties__property-value properties__property-value--multiselect">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                viewBox="0 0 32 32" fill="none">
                                                <path fill="#434D4C" fill-rule="evenodd"
                                                    d="M3.2 16a12.8 12.8 0 1 1 25.6 0 12.8 12.8 0 0 1-25.6 0ZM5.943 16a10.057 10.057 0 1 1 20.114 0 10.057 10.057 0 0 1-20.114 0Z" />
                                                <path fill="#434D4C" fill-rule="evenodd"
                                                    d="M16 9a1.371 1.371 0 0 1 1.371 1.371v7.258a1.371 1.371 0 0 1-2.742 0V10.371A1.371 1.371 0 0 1 16 9ZM14.629 21a1.371 1.371 0 1 1 2.742 0 1.371 1.371 0 0 1-2.742 0Z" />
                                            </svg>
                                            <span v-html="value"></span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>

                    </div>

                </div>

                <slot name="item-list-container"></slot>
                <slot name="feedback-container"></slot>
            </div>
        </slot>
        <div id="eusafety-wrapper">
            <div class="modal fade" id="eusafety" tabindex="-1" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title h3">
                                Herstellerinformationen
                            </div>
                            <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
                                    aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div>

                                <div v-if="hasManufacturerDataPart1">
                                    <div v-if="manufacturerData.name">
                                        {{ manufacturerData.name }}
                                    </div>
                                    <div v-if="manufacturerData.street || manufacturerData.houseNo">
                                        {{ manufacturerData.street }} {{ manufacturerData.houseNo }}
                                    </div>
                                    <div v-if="manufacturerData.postcode || manufacturerData.town">
                                        {{ manufacturerData.postcode }} {{ manufacturerData.town }}
                                    </div>
                                    <div v-if="manufacturerCountry != ''">
                                        {{ manufacturerCountry }}
                                    </div>
                                    <div v-if="manufacturerData.email">
                                        {{ manufacturerData.email }}
                                    </div>
                                </div>


                                <div class="mt-4" v-if="hasManufacturerDataPart2">
                                    <div class="h4">EU-Verantwortlicher</div>
                                    <div v-if="manufacturerData.responsibleName">{{ manufacturerData.responsibleName
                                        }}</div>
                                    <div
                                        v-if="manufacturerData.responsibleStreet || manufacturerData.responsibleHouseNo">
                                        {{ manufacturerData.responsibleStreet
                                        }} {{
                                            manufacturerData.responsibleHouseNo }}</div>
                                    <div
                                        v-if="manufacturerData.responsiblePostCode || manufacturerData.responsibleTown">
                                        {{ manufacturerData.responsiblePostCode }} {{ manufacturerData.responsibleTown
                                        }}
                                    </div>
                                    <div v-if="responsibleManufacturerCountry != ''">{{ responsibleManufacturerCountry
                                        }}
                                    </div>
                                    <div v-if="manufacturerData.responsibleEmail">{{ manufacturerData.responsibleEmail
                                        }}</div>
                                </div>

                                <div v-if="currentVariation.barcodes" class="mt-2 pt-2 border-top">EAN: {{
                                    currentVariation.barcodes[0].code }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";

import ItemStoreSpecial from "ceres/app/components/itemList/ItemStoreSpecial.vue";

export default {

    name: "single-item",

    components: {
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

    data() {
        return {
            guaranteeLabelExpanded: false
        };
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    provide() {
        return {
            itemId: this.$props.itemId
        }
    },

    computed:
    {
        guaranteeLabelBrand() {
            const manufacturer = this.currentVariation.item.manufacturer || {};

            return manufacturer.name || "";
        },

        isGuaranteeLabelVisible() {
            return !!(this.guaranteeLabelBrand
                && this.currentVariation.variation.model
                && this.currentVariation.variation.durabilityYears);
        },

        manufacturerData() {
            return this.$store.getters.currentItemVariation.item.manufacturer;
        },
        manufacturerCountry() {
            if (this.manufacturerData && this.manufacturerData.countryObject && this.manufacturerData.countryObject.names) {
                for (let key in this.manufacturerData.countryObject.names) {
                    if (this.manufacturerData.countryObject.names[key].language === "de") {
                        return this.manufacturerData.countryObject.names[key].name;
                    }
                }
            }
            return ""
        },
        hasManufacturerDataPart1() {
            if (this.manufacturerData.name || this.manufacturerData.street || this.manufacturerData.houseNo || this.manufacturerData.postCode || this.manufacturerData.responsibleTown || this.manufacturerCountry !== "" || (this.manufacturerData.email && this.manufacturerData.email !== '') || this.manufacturerData.phoneNo) {
                return true;
            }
        },
        hasManufacturerDataPart2() {
            if (this.manufacturerData.responsibleName || this.manufacturerData.responsibleStreet || this.manufacturerData.responsibleHouseNo || this.manufacturerData.responsiblePostCode || this.manufacturerData.responsibleTown || this.responsibleManufacturerCountry !== "" || (this.manufacturerData.responsibleEmail && this.manufacturerData.responsibleEmail !== '')) {
                return true;
            }
        },

        responsibleManufacturerCountry() {
            if (this.manufacturerData && this.manufacturerData.responsibleCountryObject && this.manufacturerData.responsibleCountryObject.names) {
                for (let key in this.manufacturerData.responsibleCountryObject.names) {
                    if (this.manufacturerData.responsibleCountryObject.names[key].language === "de") {
                        return this.manufacturerData.responsibleCountryObject.names[key].name;
                    }
                }
            }
            return ""
        },
        filteredVariationProperties() {
            let filteredProps = []
            for (let key in this.currentVariation.variationProperties) {
                for (let key2 in this.currentVariation.variationProperties[key].properties) {
                    if (this.currentVariation.variationProperties[key].properties[key2].id !== 81 && this.currentVariation.variationProperties[key].id !== 5 && this.currentVariation.variationProperties[key].id !== 14) {
                        filteredProps.push(this.currentVariation.variationProperties[key].properties[key2])
                    }
                }
            }

            return filteredProps
        },

        multiSelectProperties() {
            let multiSelectProps = []
            for (let key in this.currentVariation.variationProperties) {
                if (this.currentVariation.variationProperties[key].id == 14) {
                    for (let key2 in this.currentVariation.variationProperties[key].properties) {
                        multiSelectProps.push(this.currentVariation.variationProperties[key].properties[key2])
                    }
                }
            }

            return multiSelectProps
        },

        itemConfig() {
            return App.config.item.itemData;
        },

        isDescriptionTabActive() {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive() {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive() {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId() {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive() {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties() {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties() {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial() {
            return this.currentVariation.item.storeSpecial;
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },
        b2bCustomerClassArr() {
            return App.b2bCustomerClassArr;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        user() {
            return this.$store.state.user;
        },
        downLoadLink() {
            return this.findProperty(12);
        },
        isItemSet() {
            return this.$store.state.items.isItemSet;
        }
    },

    created() {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
        this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);
    },

    mounted() {
        this.$nextTick(() => {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId: this.itemId,
                attributes: this.attributesData,
                variations: this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey: this.afterKey
            });

            if (this.isItemSet) {
                this.$store.dispatch("initSetComponents", this.itemData);
            }
        })

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

    methods:
    {
        findProperty(propID) {
            if (this.currentVariation && typeof this.currentVariation.variationProperties != 'undefined' && this.currentVariation.variationProperties.length > 0) {
                const props = this.currentVariation.variationProperties[0].properties;
                const propData = props.find(p => p.id === propID);
                console.log(propData);
                if (propData && propData.values && propData.values.value) {
                    return propData.values.value;
                }
            }
            return "";
        },
        // multiselect properties deliver an array of selection values instead of a single value object
        propertyValues(property) {
            if (isNullOrUndefined(property) || isNullOrUndefined(property.values)) {
                return [];
            }

            const values = Array.isArray(property.values) ? property.values : [property.values];

            return values
                .map(value => {
                    if (isNullOrUndefined(value)) {
                        return "";
                    }

                    return !isNullOrUndefined(value.value) ? value.value : value;
                })
                .filter(value => value !== "");
        },

        getDataField(field) {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter) {
            if (!isNullOrUndefined(this.$options.filters[filter])) {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes) {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate") {
                    component.hydrate();
                }
                else if (component.$children.length) {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
const props = this.currentVariation.variationProperties[0].properties;
const propData = props.find(p => p.id === propID);
console.log(propData);
if (propData && propData.values && propData.values.value)
{
return propData.values.value;
}
}
return "";
},
getDataField(field)
{
return get(this.currentVariation, field);
},

getFilteredDataField(field, filter)
{
if (!isNullOrUndefined(this.$options.filters[filter]))
{
return this.$options.filters[filter](this.getDataField(field));
}

return this.getDataField(field);
},

// iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
hydrateChildren(nodes)
{
nodes.forEach(component => {
if (component.$options.name === "lazy-hydrate")
{
component.hydrate();
}
else if (component.$children.length)
{
this.hydrateChildren(component.$children);
}
})
}
}
}
</script>
